import React, { useState, useEffect, useRef, useMemo } from "react";
import carregando from "../../assets/loading.gif";
import api from "../../services/api";
import Header from "../../Header";
import SideMenu from "../../SideMenu";
import Footer from "../../Footer";
import {
  idStr,
  TreinamentosPermitidosModalPanel,
} from "./TreinamentosPermitidosModalPanel";

const MODAL_ID_EDIT_CLIENTE = "modal-treinamentos-edit-cliente";

export default function Edit_Cliente({ history }) {
  const [nome, setNome] = useState("");
  const [endereco, setEndereco] = useState("");
  const [divisao, setDivisao] = useState("");
  const [freqManutencao, setFreqManutencao] = useState(0);
  const [qtdeFuncionarios, setQtdeFuncionarios] = useState(0);
  const [loading, setLoading] = useState("");
  const [produtos, setProdutos] = useState([]);
  const [treinamentosPermitidos, setTreinamentosPermitidos] = useState([]);
  const modalTreinamentosPermitidosRef = useRef(null);

  const url_string = window.location.href;
  const param = url_string.split("/");

  async function loadProd() {
    const response = await api.get("/treinamentos/empresa/" + param[4]);
    const data = await response.data;

    setNome(data[0].nome);
    setEndereco(data[0].endereco);
    setDivisao(data[0].divisao);
    setFreqManutencao(data[0].freqManutencao);
    setQtdeFuncionarios(data[0].qtdeFuncionarios);
    const permitidos = data[0].treinamentosPermitidos || [];
    setTreinamentosPermitidos(permitidos.map((x) => idStr(x)));
  }

  async function loadCatalogoProdutos() {
    const empresaid = localStorage.getItem("sgiempresaid");
    const isMaster = localStorage.getItem("sgimaster");
    const response = await api.get("/treinamentos/produto", {
      headers: { "x-tenantid": empresaid, isMaster },
    });
    setProdutos(response.data || []);
  }

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    (async () => {
      try {
        await loadProd();
        if (cancelled) return;
        await loadCatalogoProdutos();
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    setTimeout(() => {
      if (document.getElementById("menu_cliente")) {
        document.getElementById("menu_cliente").className = "active";
      }
    }, 50);
    return () => {
      cancelled = true;
    };
  }, []);

  async function handleSubmit(event) {
    event.preventDefault();

    const dataobj = {
      nome: nome,
      endereco: endereco,
      divisao: divisao,
      freqManutencao: freqManutencao,
      qtdeFuncionarios: qtdeFuncionarios,
      treinamentosPermitidos: treinamentosPermitidos,
    };

    await api.put("/treinamentos/empresa/" + param[4], dataobj);
    history.push("/clientes");
  }

  function removerTreinamentoPermitido(id) {
    const sid = idStr(id);
    setTreinamentosPermitidos((prev) =>
      prev.filter((x) => idStr(x) !== sid)
    );
  }

  const catalogoTreinamentosNaoIntegracao = useMemo(
    () => (produtos || []).filter((p) => !p.isIntegracao),
    [produtos]
  );

  return (
    <>
      <Header />
      <SideMenu />

      <div className="content-wrapper">
        <section className="content-header">
          <h1>
            {nome}
            <small>&nbsp;( {nome} )</small>
          </h1>
        </section>

        <section className="content">
          <div className="row">
            <div className="col-md-12">
              <div className="box box-info">
                {loading && (
                  <div style={{ alignItems: "center", textAlign: "center" }}>
                    <img src={carregando} width="80" alt="" />
                  </div>
                )}

                <form className="form-horizontal" onSubmit={handleSubmit}>
                  <div className="box-body">
                    <div className="form-group">
                      <label className="col-sm-2 control-label" htmlFor="nome">
                        Nome*
                      </label>
                      <div className="col-sm-10">
                        <input
                          id="nome"
                          placeholder="Nome do Cliente"
                          className="form-control"
                          value={nome}
                          required
                          maxLength={400}
                          onChange={(event) => setNome(event.target.value)}
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label
                        className="col-sm-2 control-label"
                        htmlFor="endereco"
                      >
                        Endereço*
                      </label>
                      <div className="col-sm-10">
                        <input
                          id="endereco"
                          placeholder="Endereço do Cliente"
                          className="form-control"
                          value={endereco}
                          required
                          onChange={(event) => setEndereco(event.target.value)}
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label
                        className="col-sm-2 control-label"
                        htmlFor="logo"
                      >
                        Logo*
                      </label>
                      <div className="col-sm-10">
                        <input
                          type="file"
                          accept="image/png, image/jpeg"
                          id="logo"
                          placeholder="Logotipo"
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="col-sm-2 control-label">
                        Treinamentos permitidos
                      </label>
                      <div className="col-sm-10">
                        <div
                          className="box box-default"
                          style={{ marginBottom: 0 }}
                        >
                          <div className="box-body table-responsive no-padding">
                            <table className="table table-hover">
                              <tbody>
                                <tr>
                                  <th>#</th>
                                  <th>Treinamento</th>
                                  <th>Ação</th>
                                </tr>
                                {treinamentosPermitidos.length === 0 ? (
                                  <tr>
                                    <td colSpan={3} className="text-muted">
                                      Nenhum treinamento no catálogo da empresa.
                                      Use o botão abaixo para adicionar.
                                    </td>
                                  </tr>
                                ) : (
                                  treinamentosPermitidos.map((id, index) => {
                                    const sid = idStr(id);
                                    const item = catalogoTreinamentosNaoIntegracao.find(
                                      (p) => idStr(p._id) === sid
                                    );
                                    return (
                                      <tr key={sid}>
                                        <td>{index + 1}</td>
                                        <td>{item ? item.titulo : id}</td>
                                        <td>
                                          <a
                                            onClick={() =>
                                              removerTreinamentoPermitido(id)
                                            }
                                            style={{ cursor: "pointer" }}
                                            role="button"
                                            tabIndex={0}
                                            onKeyDown={(e) =>
                                              e.key === "Enter" &&
                                              removerTreinamentoPermitido(id)
                                            }
                                          >
                                            <i
                                              className="fa fa-remove"
                                              style={{ color: "red" }}
                                            />
                                          </a>
                                        </td>
                                      </tr>
                                    );
                                  })
                                )}
                              </tbody>
                            </table>
                          </div>
                          <div
                            className="box-footer"
                            style={{ borderTop: 0 }}
                          >
                            <button
                              className="btn btn-success"
                              data-toggle="modal"
                              data-target={`#${MODAL_ID_EDIT_CLIENTE}`}
                              type="button"
                              style={{ marginRight: 8 }}
                              onClick={() =>
                                modalTreinamentosPermitidosRef.current?.prepararAbertura(
                                  treinamentosPermitidos
                                )
                              }
                            >
                              + Adicionar Novo Treinamento
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="box-footer">
                    <button
                      className="btn btn-default"
                      type="button"
                      style={{ marginRight: 8 }}
                      onClick={() => history.push("/clientes")}
                    >
                      Voltar
                    </button>
                    <button type="submit" className="btn btn-info">
                      Salvar
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>

      <TreinamentosPermitidosModalPanel
        ref={modalTreinamentosPermitidosRef}
        modalId={MODAL_ID_EDIT_CLIENTE}
        catalogoProdutos={catalogoTreinamentosNaoIntegracao}
        onAplicarSelecao={setTreinamentosPermitidos}
      />

      <Footer />
    </>
  );
}
